<template>
  <div class="row">
    <div class="col-md-12 app-title">
      <h1>{{ title }}</h1>

      <div class="app-title-buttons">
        <cc-custom-action-button
          v-for="(actn, idx) in getObjActions"
          :ref="actn.name"
          :action="actn"
          :entity="entity"
          :filter="filter"
          :key="idx"
          :beforeCustomAction="beforeCustomAction"
          :prepareCustomAction="prepareCustomAction"
          :afterCustomAction="afterCustomAction"
        />

        <cc-actions
          :allowedActions="getActions"
          :entity="entity"
          @onAction="onAction"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

/* eslint-disable */

export default {
  name: 'CcTitle',

  props: {
    title: '',
    allowedActions: null,
    entity: {},
    filter: '',
    beforeCustomAction: Function,
    prepareCustomAction: Function,
    afterCustomAction: Function,
  },

  computed: {
    getObjActions() {
      return (this.allowedActions ? this.allowedActions : []).filter(a => a && a.processorName)
    },

    getActions() {
      return (this.allowedActions ? this.allowedActions : []).filter(a => a && !a.processorName)
    },
  },

  methods: {
    execAction(name) {
      if (this.$refs[name]) {
        this.$refs[name][0].showCustomActionDialog()
      } else {
        console.error(`Unable to find custom action with name '${name}'.`)
      }
    },

    onAction(action, entity) {
      this.$emit('onAllowedAction', action, entity)
    },
  },
}
</script>

<style scoped></style>
